import { WBSModels } from "modules/WBS/WBSModels";

import { FirebaseDocument } from "common/models/FirebaseDocument";
import { Location } from "modules/WBS/models/Location";
import * as firebase from "firebase/app";
//import { DocumentReference, QuerySnapshot } from '@firebase/app-types';

export class WBSResource {
  code: string;
  description: string;
  unitCost: Number;
  unit: string;
  origin: string;
  disabled: string;
  category?: string;
  locations:
    | Array<FirebaseDocument<Location>>
    | Promise<firebase.firestore.QuerySnapshot>;

  constructor(
    code: string,
    description: string,
    unitCost: Number,
    unit: string,
    origin: string,
    disabled: string,
    category?: string,
    ref?: firebase.firestore.DocumentReference
  ) {
    this.code = code;
    this.description = description;
    this.unitCost = unitCost;
    this.unit = unit;
    this.origin = origin;
    this.disabled = disabled;
    this.category = category ? category : "other";
    if (ref)
      this.locations = new Promise((resolve, reject) => {
        ref
          .collection("locations")
          .get()
          .then((snapshot) => {
            this.locations = snapshot.docs.map((row) =>
              WBSModels.locations(row)
            );
            resolve();
          });
      });
    else this.locations = [];
  }
  public static getDefault(): WBSResource {
    return new WBSResource("", "", 0, "", "", "", "other");
  }
}



// WEBPACK FOOTER //
// ./src/modules/WBS/models/WBSResource.tsx